import {
	FETCH_SCHEDULER,
	FETCH_SCHEDULERS,
	ADD_EMPTY_SCHEDULER_MESSAGE,
	REMOVE_SCHEDULER_MESSAGE,
	CLEAN_SCHEDULERS,
	SET_SCHEDULER_MESSAGE,
	UPDATE_SCHEDULER_MESSAGE,
	FETCH_SCHEDULERS_CHANNEL,
} from '../actions/types';

const schedulerInitialState = {
	id: null,
	name: '',
	description: '',
	messages: [],
};

const schedulerMessageInitialState = {
	id: null,
	text: '',
	ref_type: null,
	ref_id: null,
	due_time: '',
};

const initialState = {
	fields: [],
	data: [],
	total_count: null,
	items: [],
	current: 1,
	first: 1,
	last: 1,
	limit: 10,
	next: 1,
	previous: 1,
	total_items: 0,
	scheduler: schedulerInitialState,
	scheduler_channel: [],
};

export default function (state = initialState, action) {
	switch (action.type) {
		case FETCH_SCHEDULERS:
			return {
				...state,
				fields: action.payload.columns,
				items: action.payload.data,
				total_count: action.payload.total_count,
			};
		case FETCH_SCHEDULER:
			return {
				...state,
				scheduler: {
					...state.scheduler,
					...action.payload,
					messages: action.payload?.messages.length == 0 ? [schedulerMessageInitialState] : action.payload.messages,
				},
			};
		case SET_SCHEDULER_MESSAGE:
			const aux_array = [...state.scheduler.messages.filter((message) => message.id !== null)];

			return {
				...state,
				scheduler: {
					...state.scheduler,
					messages: [...aux_array, action.payload],
				},
			};
		case UPDATE_SCHEDULER_MESSAGE:
			return {
				...state,
				scheduler: {
					...state.scheduler,
					messages: [...state.scheduler.messages.map((message) => (message.id == action.payload.id ? action.payload : message))],
				},
			};
		case ADD_EMPTY_SCHEDULER_MESSAGE:
			return {
				...state,
				scheduler: {
					...state.scheduler,
					messages: [...state.scheduler.messages, schedulerMessageInitialState],
				},
			};
		case REMOVE_SCHEDULER_MESSAGE:
			return {
				...state,
				scheduler: {
					...state.scheduler,
					messages: state.scheduler.messages.filter((message) => message.id !== action.payload.message_id),
				},
			};
		case FETCH_SCHEDULERS_CHANNEL:
			return {
				...state,
				scheduler_channel: action.payload.data,
			};
		case CLEAN_SCHEDULERS:
			return initialState;
		default:
			return state;
	}
}
